import React, { useState, useEffect } from 'react';
import Seat from './Seat';

const SeatSelectionPage = ({ onProceedToRegistration, bookedSeats, onBack }) => {
  const [seats, setSeats] = useState([]);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const maxSeatsAllowed = 5; // Example: User can select up to 5 seats

  // Cinema layout: 4 rows, 10 seats per row with an aisle after 5th seat
  const rows = React.useMemo(() => ['A', 'B', 'C', 'D'], []);
  const seatsPerRow = 10;
  const aisleAfterSeat = 5;

  useEffect(() => {
    const initialSeats = [];
    rows.forEach(row => {
      for (let i = 1; i <= seatsPerRow; i++) {
        // If this seat is in the bookedSeats prop, use its name
        const booked = bookedSeats?.find(bs => bs.seatId === `${row}${i}`);
        
        // Add some test booked seats for demonstration
        let testBooked = null;
        if (row === 'A' && i === 1) testBooked = { name: 'John Doe' };
        if (row === 'A' && i === 2) testBooked = { name: 'Jane Smith' };
        if (row === 'B' && i === 3) testBooked = { name: 'Mike Johnson' };
        
        const finalBooked = booked || testBooked;
        
        initialSeats.push({
          id: `${row}${i}`,
          status: finalBooked ? 'booked' : 'available',
          bookedBy: finalBooked ? finalBooked.name : null,
          avatar: finalBooked ? finalBooked.avatar : null
        });
      }
    });
    setSeats(initialSeats);
  }, [bookedSeats, rows]);


  const handleSelectSeat = (seatId) => {
    const seatIndex = selectedSeats.indexOf(seatId);
    if (seatIndex > -1) {
      // Deselect seat
      setSelectedSeats(selectedSeats.filter(id => id !== seatId));
      setSeats(seats.map(seat => seat.id === seatId ? { ...seat, status: 'available' } : seat));
    } else {
      // Select seat
      if (selectedSeats.length < maxSeatsAllowed) {
        setSelectedSeats([...selectedSeats, seatId]);
        setSeats(seats.map(seat => seat.id === seatId ? { ...seat, status: 'selected' } : seat));
      } else {
        alert(`You can select a maximum of ${maxSeatsAllowed} seats.`);
      }
    }
  };

  const renderSeats = () => {
    const layout = [];
    rows.forEach(rowLabel => {
      const rowSeats = [];
      for (let seatNum = 1; seatNum <= seatsPerRow; seatNum++) {
        const seatId = `${rowLabel}${seatNum}`;
        const seatData = seats.find(s => s.id === seatId);
        rowSeats.push(
          <Seat
            key={seatId}
            seatId={seatId}
            status={seatData ? seatData.status : 'booked'}
            bookedBy={seatData ? seatData.bookedBy : null}
            onSelectSeat={handleSelectSeat}
            isAisle={false}
          />
        );
        if (seatNum === aisleAfterSeat) {
          rowSeats.push(<div key={`${rowLabel}-aisle`} className="seat aisle"></div>);
        }
      }
      layout.push(
        <div key={rowLabel} className="cinema-row">
          {rowSeats}
        </div>
      );
    });
    return layout;
  };

  return (
    <div className="seat-selection-page">
      <button className="back-btn" onClick={onBack}>&larr; Back</button>

      <div className="seat-selection-container">
        <div className="seat-selection-header">
          <h1 className="seat-selection-title">Chọn ghế của bạn</h1>
        </div>

        <div className="screen">MÀN HÌNH</div>

        <div className="cinema-layout">
          {seats.length > 0 ? renderSeats() : <p>Loading seats...</p>}
        </div>

        <div className="seat-legend">
          <div className="legend-item">
            <div className="legend-color legend-available"></div>
            <span>Trống</span>
          </div>
          <div className="legend-item">
            <div className="legend-color legend-selected"></div>
            <span>Đã chọn</span>
          </div>
          <div className="legend-item">
            <div className="legend-color legend-booked"></div>
            <span>Đã đặt</span>
          </div>
        </div>

        <div className="selected-seats-info">
          {selectedSeats.length > 0 ? (
            <p>Ghế đã chọn: <strong>{selectedSeats.join(', ')}</strong> ({selectedSeats.length}/{maxSeatsAllowed})</p>
          ) : (
            <p>Vui lòng chọn ghế.</p>
          )}
        </div>

        <button
          className="proceed-btn btn btn-success btn-lg"
          onClick={() => onProceedToRegistration(selectedSeats)}
          disabled={selectedSeats.length === 0}
        >
          Tiếp tục đăng ký
        </button>
      </div>
    </div>
  );
};

export default SeatSelectionPage;
